import { a as a$1 } from './chunk-O54VISTG.mjs';
import { b, a } from './chunk-6EFRS222.mjs';
import { useEffect } from 'react';
import { Content, Title, Close, Description, DialogClose, Root, Trigger, Portal } from '@radix-ui/react-dialog';
import e, { css } from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var d=e.div`
  @keyframes overlayShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  z-index: var(--z-index-200);
  background-color: var(--overlay-100);
  position: fixed;
  inset: 0;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
`,r=e.div`
  display: flex;
  gap: var(--spacing-regular);
  justify-content: right;
`,M=css`
  width: 416px;
  padding: var(--spacing-x-large);
  ${r} {
    margin-top: var(--spacing-x-large);
  }
`,P=css`
  width: 920px;
`,c=e(Content)`
  @keyframes contentShow {
    from {
      opacity: 0;
      transform: translate(-50%, -48%) scale(0.96);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  z-index: var(--z-index-200);
  color: var(--${b});
  ${a};
  background-color: var(--background-level-1);
  border-radius: var(--border-radius-small, 6px);
  box-shadow: var(--elevation-400);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 416px;
  width: var(--content-modal-width);
  max-height: 100vh;
  overflow: auto;
  padding: var(--spacing-x-x-large);
  animation: contentShow 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  gap: var(--spacing-regular);
  flex-direction: column;

  ${r} {
    margin-top: var(--spacing-x-x-large);
  }

  ${({$size:o})=>o==="small"&&M}
  ${({$size:o})=>o==="large"&&P}
`,m=e(Title)`
  ${a$1};
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
`,g=e(Close)`
  color: var(--${b});
  position: absolute;
  top: var(--spacing-large);
  right: var(--spacing-large);
  border: none;
  background: none;
  cursor: pointer;
`;var u=({children:o,trigger:n,size:f="regular",modal:x=!0,open:t,onOpenChange:y,onOpenAutoFocus:h,container:b=document.body,...C})=>(useEffect(()=>(document.body.style.overflow=t?"hidden":"",()=>{document.body.style.overflow="";}),[t]),jsxs(Root,{modal:x,open:t,onOpenChange:y,...C,children:[n&&jsx(Trigger,{asChild:!0,children:n}),jsxs(Portal,{container:b,children:[jsx(d,{}),jsx(c,{$size:f,onOpenAutoFocus:h,children:o})]})]}));u.displayName="Modal";var L={Root:u,Title:m,Description:Description,Close:g,Actions:r,DialogClose:DialogClose};

export { L as a };
